var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._b({}, "el-dialog", _vm.$attrs, false),
    [
      _c("p", { staticStyle: { "margin-bottom": "1vh" } }, [
        _vm._v("当前企业信息：" + _vm._s(_vm.UserForm.name))
      ]),
      _c(
        "el-form",
        {
          ref: "changeNameRef",
          staticClass: "user-form-sty",
          attrs: {
            "label-width": "100px",
            size: "small",
            model: _vm.accountForm,
            rules: _vm.accountRules
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "新企业名称：", prop: "name" } },
            [
              _c(
                "div",
                { staticClass: "item-box" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入新企业名称" },
                    model: {
                      value: _vm.accountForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.accountForm, "name", $$v)
                      },
                      expression: "accountForm.name"
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("p", { staticStyle: { color: "#ec1c1c" } }, [
        _vm._v("请确保更改的名称与工商变更后的企业名称完全一致")
      ]),
      _c("p", [
        _c("span", { staticStyle: { color: "#ec1c1c" } }, [_vm._v("注：")]),
        _vm._v(
          "如因信息变更出现数据异常，以及后续所产生的一切法律责任均由您自行承担。"
        )
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("update:visible", false)
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.changeNameHand } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f4a137a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4a137a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/components/accountInfo/popups/changeAccount.vue
// module id = DDZP
// module chunks = 0 61 86 145 210